
/*------------------------------------------------------------------
  - This sccript for adding product variants for seller to sell his item
-------------------------------------------------------------------*/


$( document ).ready(function() { 
  $('.product_variants_option_value_1').dropdown({allowAdditions: true,maxSelections: 50});
  $('.product_variants_option_value_2').dropdown({allowAdditions: true,maxSelections: 50});
  $('.product_variants_option_value_3').dropdown({allowAdditions: true,maxSelections: 50});
  //Opening modal window
  //Opening modal window on click of button
  $('.add_variant_btn').click(function (){
    $('.product_variants_option_2').dropdown({allowAdditions: true});
    var addProductVariantPopup = $('.add-variants-modal');
  	addProductVariantPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      closeClass: 'modal__close'
    });
  });
  
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }
  
  
  function checkVariantLength() {
    var option1 = $('#variant_option_value_1').val().split(',').length;
    var option2 = $('#variant_option_value_2').val().split(',').length;
    var option3 = $('#variant_option_value_3').val().split(',').length;
	var totalCombination = option1 * option2 * option3;
    //console.log(totalCombination);
    $('.api_error').hide();
    $('.api_success').hide();
    if(totalCombination > 100){
      console.log("Variation crossed limit");
      $("#add_variant_error").html("Products can’t have more than 100 variants combinations.").fadeIn();
      return false;
    }
    return true;
  }
  
  
  // Show product details tab
  $('.variant_submit').click(function (e){
    e.preventDefault();
    if(checkVariantLength()) {
      $(".loding_container").show();
      setTimeout(function() { $('#add_variant_form').submit();
                            }, 100);
    }
  });
 
  
  //Saving new product data
  $("form#add_variant_form").submit(function(e){
    e.preventDefault();
    $(".loding_container").fadeIn();

    var addProductSubmitBtn = $('#variant_submit');  // submit button
    addProductSubmitBtn.html('Saving...');
    addProductSubmitBtn.prop('disabled', true); // disable button
    addProductSubmitBtn.attr("disabled", true); // disable button
    var formData = new FormData($("#add_variant_form")[0]);
    var token = readCookie('token');

    $.ajax({
     url: 'https://api-test.lovethisstuff.com/v1/products/addVariantAPI?token='+token+'',

     // url: "https://test-designers.lovethisstuff.com/website/product/addProductVariant",
      type: 'POST',
      data: formData,
      processData: false,
      async: true,
      beforeSend: function() {
        addProductSubmitBtn.html('Saving ...');
        addProductSubmitBtn.prop('disabled', true); // disable button
        addProductSubmitBtn.attr('disabled', true); // disable button
      },
      success: function (data) {
        $(".loding_container").fadeOut();
        if(data.messageType === "SUCCESS") {
          addProductSubmitBtn.html('Saved');
          addProductSubmitBtn.prop('disabled', true); // disable button
          addProductSubmitBtn.attr('disabled', true); // disable button
          $('.api_error').hide();
          $('.api_success').hide();
          $('#add_variant_success').html(data.message).fadeIn();
          setTimeout(function(){location.reload();},700);
        } else if(data.messageType === "SESSION_EXPIRED" || data.messageType === "UNAPPROVED") {
          addProductSubmitBtn.html('Submit'); // change submit button text
          addProductSubmitBtn.attr('disabled', false); // disable button
          $('.api_success').hide();
          $('.api_error').hide();
          $('#add_variant_error').html(data.message).fadeIn();
        }
      },
      error : function (data) {
        $(".loding_container").fadeOut();
        addProductSubmitBtn.html('Submit'); // change submit button text
        addProductSubmitBtn.attr("disabled", false); // Enabling button
        addProductSubmitBtn.prop('disabled', false); // disable button
        $('.api_success').hide();
        $('.api_error').hide();
        $('#add_variant_error').html(data.message).fadeIn();
      },
      cache: false,
      contentType: false,
      processData: false
    });
    return false;
  });
	
});